import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateAgentCategoryDto } from '../../dtos/create-agent-category.dto';
import { UpdateAgentCategoryDto } from '../../dtos/update-agent-category.dto';
import { createAgentCategorySchema } from '../schemas/create-agent-category.schema';
import { updateAgentCategorySchema } from '../schemas/update-agent-category.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateAgentCategoryDto | UpdateAgentCategoryDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateAgentCategorySchema if 'id' is present
		validationResult = updateAgentCategorySchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createAgentCategorySchema if 'id' is not present
		validationResult = createAgentCategorySchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
